import i18n from '@/utils/i18n';
import React from 'react';
import { Chip } from '@usepepper/sprout-kit-ui';
import { createStyles } from '@/contexts/theme-context';
import { View } from 'react-native';

interface CopilotNewSessionButtonProps {
  onPress: () => void;
}

export const CopilotNewSessionButton: React.FC<
  CopilotNewSessionButtonProps
> = ({ onPress }) => {
  const [styles] = useStyles();

  return (
    <View style={styles.absolutePosition}>
      <Chip
        accessibilityLabel={i18n.t('sales_portal.copilot.new_session')}
        circular
        onPress={onPress}
        pressable
      >
        <Chip.Text>{i18n.t('sales_portal.copilot.new_session')}</Chip.Text>
      </Chip>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  absolutePosition: {
    alignSelf: 'center',
    position: 'absolute',
    top: theme.sk.spacing.spaceMedium,
    zIndex: 1,
  },
}));
